if (!customElements.get('vega-collection-image')) {
    class ImageSwiper extends HTMLElement {
        /**
         * Section settings (only part)
         */
        sectionSettings;

        /**
         * Swiper entity
         * 
         * @type {Swiper}
         */
        mySwiper;

        constructor() {
            super();
            this.sectionSettings = JSON.parse(this.getAttribute("data-settings").replaceAll("/'", '"'));
            this.layoutPc = this.sectionSettings.layout_pc || 'slider';
            this.layoutMb = this.sectionSettings.layout_mb || 'slider';
        }

        connectedCallback() {
            this.isMobileMQL = window.matchMedia('(max-width: 990px)');
            if (this.shouldUseSlider()) {
                this.createSwiper();
            }
            if (this.layoutPc !== this.layoutMb) {
                this._handleMediaChange = this.handleMediaChange.bind(this);
                this.isMobileMQL.addEventListener('change', this._handleMediaChange);
            }
            this.initEvent();
        }

        disconnectedCallback() {
            if (this.isMobileMQL && this._handleMediaChange) {
                this.isMobileMQL.removeEventListener('change', this._handleMediaChange);
            }
            this.destroySwiper();
        }

        shouldUseSlider() {
            if (this.isMobileMQL.matches) {
                return this.layoutMb === 'slider';
            }
            return this.layoutPc === 'slider';
        }

        createSwiper() {
            if (this.mySwiper) {
                return;
            }
            this.mySwiper = new Swiper(this.querySelector(`.image_swiper_container`), {
                loop: false,
                spaceBetween: 0,
                slidesPerView: 1,
                centeredSlides: false,
                observer: true,
                resizeObserver: true,
                navigation: {
                    nextEl: this.querySelector(`.swiper-btn-next`),
                    prevEl: this.querySelector(`.swiper-btn-prev`),
                },
                pagination: {
                    el: this.querySelector(`#${this.id} .swiper-pagination`),
                    clickable: true,
                },
                on: {
                    slideChange: this.handleSlideChange.bind(this),
                },
                scrollbar: {
                    el: this.querySelector(`#${this.id} .swiper-scrollbar`),
                },
                breakpoints: {
                    1280: {
                        slidesPerView: this.sectionSettings.image_columns_pc,
                        spaceBetween: 40,
                    },
                    768: {
                        slidesPerView: this.sectionSettings.image_columns_pad,
                        spaceBetween: 30,
                    },
                    375: {
                        slidesPerView: this.sectionSettings.image_columns_mb,
                        spaceBetween: 15,
                    },
                },
            });
        }

        destroySwiper() {
            if (this.mySwiper) {
                this.mySwiper.destroy(true, true);
                this.mySwiper = null;
            }
        }

        handleMediaChange() {
            this.destroySwiper();
            if (this.shouldUseSlider()) {
                this.createSwiper();
            }
        }

        /**
         * 轮播图切换事件
         */
        handleSlideChange(swiper) {
        }

        initEvent() {
        }
    }

    customElements.define('vega-collection-image', ImageSwiper);
}
